import { useState } from "react";
import axios from 'axios';

export default function BannerSettings() {
  const [bannerText, setBannerText] = useState(
    "We've just launched our Experience Center!"
  );
  const [bannerStyle, setBannerStyle] = useState({
    bold: true,
    italic: false,
    underline: false,
  });

  const [linkUrl, setLinkUrl] = useState("");
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  // Toggle text style
  const toggleStyle = (style) => {
    setBannerStyle((prev) => ({ ...prev, [style]: !prev[style] }));
  };

  // Handle banner creation
  const handleCreate = async () => {
    const payload = {
      text: bannerText,
      bold: bannerStyle.bold,
      italic: bannerStyle.italic,
      underline: bannerStyle.underline,
      link: linkUrl,
    };

    try {
      const res = await axios.post(`${API_BASE}banner`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      alert("Banner updated successfully!");
    } catch (error) {
      console.error(error);
      alert("Error uploading banner");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md">
      {/* Heading */}
      <h2 className="text-xl font-bold mb-4 text-gray-800">Banner Settings</h2>

      {/* Live Banner Preview */}
      <div className="w-full mb-6">
        <div
          className={`w-full py-4 px-6 rounded text-white text-center bg-blue-700 
          ${bannerStyle.bold ? "font-bold" : "font-normal"} 
          ${bannerStyle.italic ? "italic" : ""} 
          ${bannerStyle.underline ? "underline" : ""}`}
        >
          {bannerText}
        </div>
      </div>

      {/* Banner settings panel */}
      <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Banner Text
          </label>
          <textarea
            value={bannerText}
            onChange={(e) => setBannerText(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            rows={3}
            placeholder="Enter your banner text here..."
          />
        </div>

        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Banner Link (Optional)
          </label>
          <div className="flex">
            <input
              type="text"
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
              className="flex-1 p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="https://your-link-destination.com"
            />
          </div>
          <p className="text-xs text-gray-500 mt-1">
            Add a URL to make the entire banner clickable (include https://)
          </p>
        </div>

        {/* Style Controls */}
        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Text Formatting
          </label>
          <div className="flex flex-wrap gap-2">
            {[
              { id: "bold", label: "Bold" },
              { id: "italic", label: "Italic" },
              { id: "underline", label: "Underline" },
            ].map((style) => (
              <button
                key={style.id}
                onClick={() => toggleStyle(style.id)}
                className={`px-4 py-2 border rounded-md cursor-pointer transition-colors ${bannerStyle[style.id]
                  ? "bg-blue-600 text-white border-blue-700"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }`}
              >
                {style.label}
              </button>
            ))}
          </div>
        </div>

        {/* Upload Button */}
        <button
          onClick={handleCreate}
          className="bg-blue-700 hover:bg-blue-800 text-white px-5 py-2 rounded-md font-medium transition-colors cursor-pointer"
        >
          Create
        </button>
      </div>
    </div>
  );
}
